import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { EShoppingCartMenuAction } from '../direct-ticket-configuration-shopping-cart/direct-ticket-configuration-shopping-cart.component';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType } from '@web/dtos';
import { HoverHighlight } from '../../../directives/hover-highlight';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { Router } from '@angular/router';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';

interface ISubMenuItem {
  icon: string;
  translationKey: ERelationType;
  action: EShoppingCartMenuAction;
  isHidden?: boolean;
}

@Component({
  selector: 'aw-direct-ticket-shopping-cart-sub-menu',
  imports: [NgClass, NgStyle, HoverHighlight, FilterTextsPipe, LanguagePipe],
  templateUrl: './direct-ticket-shopping-cart-sub-menu.component.html',
})
export class DirectTicketShoppingCartSubMenuComponent {
  public readonly darkModeBorderColor: InputSignal<string> =
    input<string>('#FFFFFF');

  public readonly onSubmenuClick: OutputEmitterRef<EShoppingCartMenuAction> =
    output();

  private readonly router: Router = inject(Router);
  protected readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );
  private readonly shoppingCartService: ShoppingCartService =
    inject(ShoppingCartService);
  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected readonly highlightedItem: WritableSignal<number | undefined> =
    signal(undefined);
  protected readonly isDarkMode: Signal<boolean> =
    this.corporateDesign.isDarkModeActive;
  public readonly darkModeColor: string =
    this.corporateDesignStore.corporateDesign().colorAdmixtures.dark_surface_01;
  protected readonly subMenuItems: ISubMenuItem[] = [
    {
      icon: 'edit',
      translationKey: ERelationType.shoppingCartTicketEditLabel,
      action: EShoppingCartMenuAction.editOptions,
      isHidden: this.router.url.includes('ticket-configuration'),
    },
    {
      icon: 'edit',
      translationKey: ERelationType.shoppingCartPassengerDataLabel,
      action: EShoppingCartMenuAction.editOwner,
      isHidden:
        this.router.url.includes('ticket-configuration') ||
        !this.shoppingCartService.personalDataForm.valid,
    },
    {
      icon: 'info',
      translationKey: ERelationType.shoppingCartTicketInfoLabel,
      action: EShoppingCartMenuAction.info,
    },
    {
      icon: 'delete',
      translationKey: ERelationType.shoppingCartTicketDeleteLabel,
      action: EShoppingCartMenuAction.delete,
      isHidden: this.router.url.includes('ticket-configuration'),
    },
  ];

  protected readonly EEntityType: typeof EEntityType = EEntityType;

  public setHighlightedItem(isHovered: boolean, index: number): void {
    if (isHovered) {
      this.highlightedItem.set(index);
    }
  }
}
